import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import Button from './Button';
import * as styles from './CopyLinkButton.module.scss';
import SVGIcon from './SVGIcon';
import Tooltip from './Tooltip';
import linkIcon from '../icons/non-prefilled/16x16/link.svg';

interface CopyLinkButtonProps {
  onCopyLink: () => void;
  children: React.ReactNode;
  className?: string;
}

const CopyLinkButton = ({
  children,
  onCopyLink,
  className,
}: CopyLinkButtonProps) => {
  const timoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isCopied, setIsCopied] = useState(false);

  return (
    <Tooltip open={isCopied} content="Link copied">
      <Button
        className={classNames(styles.copyLinkButton, className)}
        onBlur={() => setIsCopied(false)}
        onClick={() => {
          onCopyLink();
          setIsCopied(true);
          if (timoutRef.current) {
            clearTimeout(timoutRef.current);
          }
          timoutRef.current = setTimeout(() => {
            setIsCopied(false);
          }, 1500);
        }}
      >
        {children}
        <div className={styles.copyLinkButtonIcon}>
          <SVGIcon>{linkIcon}</SVGIcon>
        </div>
      </Button>
    </Tooltip>
  );
};

export default CopyLinkButton;
